import { ref } from 'vue';

/**
 * Represents the identifier of the student for which events are being tracked.
 */
const studentId = ref<number | undefined>(undefined);

export function setStudentId(id: number | undefined): void {
    studentId.value = id;
}

export default function useAuthenticatedStudent() {
    return { studentId };
}
